export default class ShowMoreDates {
  constructor() {
    this.element = document.querySelector('.js-showmoredates-container')
    this.trigger = document.querySelector('.js-showmoredates-trigger')

    if (!this.element || !this.trigger) {
      return
    }

    this.init()
  }

  init() {
    this.trigger.addEventListener('click', () => {
      if (this.element.classList.contains('hidden')) {
        this.element.classList.remove('hidden')
        this.trigger.innerHTML = 'Toon minder data'
      } else {
        this.element.classList.add('hidden')
        this.trigger.innerHTML = 'Toon meer data'
      }
    })
  }
}
